import {
  Dialog,
  DialogBackdrop,
  DialogPanel,
  DialogTitle,
} from "@headlessui/react";
import { useFormik } from "formik";
import React, { useState } from "react";
import { toast } from "react-toastify";
import * as Yup from "yup";
import { getApiCaller } from "../../libs/apiCaller";
import { useUnauthorizedNavigation } from "../../libs/UnauthorisedPage";

const SendNotification = ({
  isOpen,
  onClose,
  notificationMobileNumber,
  id,
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const redirectToLogin = useUnauthorizedNavigation();

  // Formik setup with validation
  const formik = useFormik({
    initialValues: {
      message: "",
    },
    validationSchema: Yup.object({
      message: Yup.string().required("Message is required"),
      // .min(5, "Message must be at least 5 characters")
      // .max(200, "Message must not exceed 200 characters")
    }),
    onSubmit: async (values) => {
      setIsLoading(true);
      const endPoint = `admin_send_notification?user_id=${id}&message=${values.message}`;
      try {
        const response = await getApiCaller(endPoint);
        if (response?.data?.response_code === 200) {
          toast.success("Notification sent successfully!");
          formik.resetForm();
        }
      } catch (error) {
        toast.error("Failed to fetch data.");
      }
      onClose();
      setIsLoading(false);
    },
  });

  return (
    <Dialog
      open={isOpen}
      onClose={() => {
        onClose();
        formik.resetForm();
      }}
      className="relative z-50"
    >
      <DialogBackdrop className="fixed inset-0 bg-gray-500/75 transition-opacity" />

      <div className="fixed inset-0 z-50 overflow-y-auto">
        <div className="flex min-h-full items-center justify-center p-4">
          <DialogPanel className="relative w-full transform overflow-hidden bg-white text-left shadow-xl transition-all rounded-lg sm:max-w-md md:max-w-lg">
            <div className="bg-[#21140E0F] px-4 pb-6 pt-3 sm:px-6">
              <div className="flex justify-between items-center mb-4">
                <DialogTitle className="text-lg sm:text-xl font-bold text-[#284184]">
                  Send Notification
                </DialogTitle>
                <button
                  onClick={() => {
                    onClose();
                    formik.resetForm();
                  }}
                  className="text-[#1C2024] hover:bg-gray-100 p-1.5 rounded-full transition-colors"
                >
                  <span className="text-2xl sm:text-4xl leading-none">
                    &times;
                  </span>
                </button>
              </div>
              <form onSubmit={formik.handleSubmit}>
                {/* Phone Number Input */}
                <div className="mb-4">
                  <label
                    htmlFor="phoneNumber"
                    className="block mb-2 text-sm font-medium text-gray-900"
                  >
                    Phone Number
                  </label>
                  <input
                    id="phoneNumber"
                    name="phoneNumber"
                    type="text"
                    value={notificationMobileNumber}
                    className={`w-full rounded-md border py-2 px-3 text-sm sm:text-base focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-shadow`}
                    disabled={true}
                  />
                </div>

                {/* Notification Message Input */}
                <div className="mb-4">
                  <label
                    htmlFor="message"
                    className="block mb-2 text-sm font-medium text-gray-900"
                  >
                    Notification Message
                  </label>
                  <textarea
                    id="message"
                    name="message"
                    rows="4"
                    className={`w-full rounded-md border py-2 px-3 text-sm sm:text-base focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-shadow ${
                      formik.errors.message && formik.touched.message
                        ? "border-red-500"
                        : "border-gray-300"
                    }`}
                    {...formik.getFieldProps("message")}
                  />
                  {formik.touched.message && formik.errors.message && (
                    <div className="text-sm text-red-500 mt-1">
                      {formik.errors.message}
                    </div>
                  )}
                </div>

                {/* Buttons */}
                <div className="flex gap-3 mt-6">
                  <button
                    type="button"
                    onClick={() => {
                      onClose();
                      formik.resetForm();
                    }}
                    className="w-full rounded-md border font-bold border-[#F04438] bg-white px-3 sm:px-4 py-2 text-sm text-[#F04438]"
                  >
                    Cancel
                  </button>
                  <button
                    type="submit"
                    className="w-full rounded-md border font-bold border-transparent bg-[#284184] px-3 sm:px-4 py-2 text-sm text-white"
                    disabled={isLoading}
                  >
                    {isLoading ? "Loading..." : "Send"}
                  </button>
                </div>
              </form>
            </div>
          </DialogPanel>
        </div>
      </div>
    </Dialog>
  );
};

export default SendNotification;
